// ------------------------------------
// Fetch Actions
// ------------------------------------
export const FETCH_REQUEST = 'FETCH_REQUEST';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_FAILURE = 'FETCH_FAILURE';

// Get Team Data
export const GET_TEAM_DATA = 'GET_TEAM_DATA';


// WEBPACK FOOTER //
// ./src/actionTypes/index.js